let input_id: number = 0;

export const input_id_user_profile_avatar = `input_id_${input_id++}`;
export const input_id_user_hotel_photos = `input_id_${input_id++}`;
